
    import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/utility/js/no-focusable-svg';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/utility/ie-warning/js/ie-warning';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/cookies/js/cookies';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/bookmark/js/bookmark';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/drop-block/js/drop-block';

import Citation from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/citation/js/citation';
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/erp-acceptance/js/erp-acceptance';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/accordion/js/accordion';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/components/back-to-top/js/back-to-top';

import LoginForm from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/login-form/js/login-form';
import Registration from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/raa/widgets/registration/js/registration';
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/quick-search/js/quick-search';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/additional-citation-info/js/additional-citation-info';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/multi-search/js/multi-search';

import TableOfContent from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/table-of-content/js/table-of-content';
import Shibboleth from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/raa/widgets/shibboleth/js/shibboleth';
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/raa/widgets/addresses/js/addresses';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/raa/js/profile';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/raa/js/raa';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/register/js/register';

import './groups/_modal';

import mobileMenuMain from './groups/_mobile-menu';
import stickyMain from './groups/_sticky';
import mathjaxMain from './groups/_mathjax';
const main = (UX) => {
    const $bookmark = Array.prototype.slice.call(document.getElementsByClassName('header__dropzone-bookmark')),
        $dropBlock = Array.prototype.slice.call(document.querySelectorAll('[data-db-target-for]')),
        $citation = Array.prototype.slice.call(document.getElementsByClassName('loa-authors-trunc')),
        $ERPAcceptance = Array.prototype.slice.call(document.getElementsByClassName('ERP-acceptance')),
        $accordion = Array.prototype.slice.call(document.getElementsByClassName('accordion')),
        $backToTop = Array.prototype.slice.call(document.getElementsByClassName('back-to-top')),
        $loginForm = Array.prototype.slice.call(document.getElementsByClassName('login-form')),
        $registration = Array.prototype.slice.call(document.querySelectorAll('.registration,.registration-completed,[registrationCompleted = true]')),
        $quickSearch = Array.prototype.slice.call(document.getElementsByClassName('quick-search')),
        $multiSearch = Array.prototype.slice.call(document.getElementsByClassName('multi-search')),
        $tableOfContent = Array.prototype.slice.call(document.getElementsByClassName('table-of-content')),
        $shibboleth = Array.prototype.slice.call(document.getElementsByClassName('shibboleth'))

try {
        UX.noFocusableSVG.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($bookmark.length ) {
            UX.bookmark.init($bookmark);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($dropBlock.length ) {
            UX.dropBlock.init($dropBlock);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($citation.length ) {
            UX.citation = new Citation($citation)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($ERPAcceptance.length ) {
            UX.ERPAcceptance.init($ERPAcceptance);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($accordion.length ) {
            UX.accordion.init($accordion);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($backToTop.length ) {
            UX.backToTop.init($backToTop);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($loginForm.length ) {
            UX.loginForm = new LoginForm($loginForm)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($registration.length ) {
            UX.registration = new Registration($registration)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($quickSearch.length ) {
            UX.quickSearch.init($quickSearch);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($multiSearch.length ) {
            UX.multiSearch.init($multiSearch);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($tableOfContent.length ) {
            UX.tableOfContent = new TableOfContent($tableOfContent)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($shibboleth.length ) {
            UX.shibboleth = new Shibboleth($shibboleth)
        }
    } catch (err) {
        console.error(err);
    }
    
mobileMenuMain(UX);

stickyMain(UX);

mathjaxMain(UX);

}

    export default main;
        